/**
 * Line-based diff for NeoAi preview (no external deps).
 * @returns {{ type: 'equal'|'add'|'remove', text: string }[]}
 */
export function diffLineChunks(beforeText, afterText) {
  const before = typeof beforeText === 'string' ? beforeText : '';
  const after = typeof afterText === 'string' ? afterText : '';

  if (before === after) {
    return before ? [{ type: 'equal', text: before }] : [];
  }

  const oldLines = before.split('\n');
  const newLines = after.split('\n');
  const n = oldLines.length;
  const m = newLines.length;

  const dp = Array.from({ length: n + 1 }, () => Array(m + 1).fill(0));
  for (let i = n - 1; i >= 0; i -= 1) {
    for (let j = m - 1; j >= 0; j -= 1) {
      if (oldLines[i] === newLines[j]) {
        dp[i][j] = 1 + dp[i + 1][j + 1];
      } else {
        dp[i][j] = Math.max(dp[i + 1][j], dp[i][j + 1]);
      }
    }
  }

  const raw = [];
  let i = 0;
  let j = 0;
  while (i < n && j < m) {
    if (oldLines[i] === newLines[j]) {
      raw.push({ type: 'equal', text: oldLines[i] });
      i += 1;
      j += 1;
    } else if (dp[i + 1][j] >= dp[i][j + 1]) {
      raw.push({ type: 'remove', text: oldLines[i] });
      i += 1;
    } else {
      raw.push({ type: 'add', text: newLines[j] });
      j += 1;
    }
  }
  while (i < n) {
    raw.push({ type: 'remove', text: oldLines[i] });
    i += 1;
  }
  while (j < m) {
    raw.push({ type: 'add', text: newLines[j] });
    j += 1;
  }

  return mergeAdjacentDiffChunks(raw);
}

function mergeAdjacentDiffChunks(chunks) {
  if (!chunks.length) return chunks;
  const merged = [{ ...chunks[0] }];
  for (let k = 1; k < chunks.length; k += 1) {
    const prev = merged[merged.length - 1];
    const cur = chunks[k];
    if (prev.type === cur.type) {
      prev.text = `${prev.text}\n${cur.text}`;
    } else {
      merged.push({ ...cur });
    }
  }
  return merged;
}

/** Prefer focused segment diff when anchors define the edited clause. */
export function pickDiffTexts(preview) {
  if (!preview || typeof preview !== 'object') {
    return { before: '', after: '', focused: false };
  }

  const segBefore = preview.changedSegmentBefore;
  const segAfter = preview.changedSegmentAfter;
  if (
    typeof segBefore === 'string' &&
    typeof segAfter === 'string' &&
    (segBefore !== segAfter || preview.summary === 'replace_between_anchors')
  ) {
    return { before: segBefore, after: segAfter, focused: true };
  }

  return {
    before: preview.before || '',
    after: preview.after || '',
    focused: false,
  };
}
